import { Box, Stack } from "@mui/material";
import { MerchantCompleteRegistrationPageStepNavigator } from "Components/Hunter/Merchants/CompleteRegistration/MerchantCompleteRegistrationPageStepNavigator";
import type { MerchantCompleteRegistrationStep } from "Components/Hunter/Merchants/CompleteRegistration/types";
import { Stepper } from "Components/Shared/Stepper/Stepper";
import type { MerchantDetailDto } from "Infrastructure/Api/Api";
import { useSearchParams } from "Navigation/useSearchParams";

type Props = {
  steps: ReadonlyArray<MerchantCompleteRegistrationStep>;
  merchantDetail: MerchantDetailDto;
  activeStepIndex: number;
};

export const MerchantCompleteRegistrationPageStepper = ({
  steps,
  merchantDetail,
  activeStepIndex,
}: Props) => {
  const [_, setSearchParams] = useSearchParams();

  return (
    <Stack gap={3}>
      <Stepper
        nonLinear
        steps={steps}
        sx={{ width: "100%" }}
        activeStepIndex={activeStepIndex}
        onStepClick={(stepIndex) => {
          setSearchParams({ activeStep: steps[stepIndex].id });
        }}
      />
      <Box width="100%" maxWidth="600px">
        <MerchantCompleteRegistrationPageStepNavigator
          steps={steps}
          merchantDetail={merchantDetail}
          activeStepIndex={activeStepIndex}
        />
      </Box>
    </Stack>
  );
};
